import { DynamicRecord } from './../../../../components/Shared/Dynamicform/DynamicFormData';
import { Resource } from "@/infrastructure/resource/resource"
import { AsyncCommand } from "../Command";
import { DynamicDataSet, DynamicFormData } from "@/components/Shared/Dynamicform/DynamicFormData";
import { StateMachine,StateMachineServiceLocator } from "@/business/application/statemachine/StateMachine";
import { changeNavigation } from "@/infrastructure/observables/NavStateNotification";

export class ServerLoadForm extends AsyncCommand {
  private dynamicForm: DynamicFormData;
  private dataSet: DynamicDataSet;
  private _store: any;
  private stateMachine: StateMachine;
  private _result: DynamicRecord[] | undefined

  
  constructor(dynamicForm: DynamicFormData,dataSet: DynamicDataSet, store: any,result: DynamicRecord[] | undefined) {
    super();
    this.dynamicForm = dynamicForm;
    this.dataSet = dataSet;
    this._store = store;
    this._result = result
    this.stateMachine = StateMachineServiceLocator.get();
  }

  public async asyncExecute(): Promise<any> {
    try {
      
      const result = await this.dynamicForm.getRemoteForm(
        this.dataSet.apiLoadMethod ?? "",
        this.dataSet.viewId,       
        this.dynamicForm.clientRouteName ?? "",
        this.dataSet.id ?? "",
        this._result
      );
      
      return result;
     } catch (e) {
       this.stateMachine.last()
       changeNavigation(this._store)       
     }
  }
}
